import actionCreator from "helpers/actionCreator"
import { createReducer } from "reduxsauce"
import update from "immutability-helper"
import { chain } from "lodash"
import { createDefaultReducer } from "helpers/reducers"
import { takeLatest, call, select, put, all } from "redux-saga/effects"
import { post as apiPost } from "api"
import { Creators as NotificationCreators } from "modules/notifications/model"
import { getSelectedAccount } from "modules/account-root/selectors"
import { getCreatedSharedLinks } from "./selectors"

export const { Types, Creators } = actionCreator("ompnt/modules/share-my-view", {
  createSharedLink: ["sharedLink"],
  setSharedLink: ["sharedLink"],
  closeDialog: [],
  addCreatedSharedLink: ["shortUrl", "sharedLink"],
})

const DEFAULT_STATE = {
  sharedLink: "",
  createdSharedLinks: [],
}

function handleAddGeneratedSharedLink(state, { shortUrl, sharedLink }) {
  return update(state, {
    createdSharedLinks: { $push: [{ shortUrl, sharedLink }] },
  })
}

export default createReducer(DEFAULT_STATE, {
  [Types.SET_SHARED_LINK]: createDefaultReducer(),
  [Types.CLOSE_DIALOG]: createDefaultReducer({ customStateValues: DEFAULT_STATE }),
  [Types.ADD_CREATED_SHARED_LINK]: handleAddGeneratedSharedLink,
})

function* handleCreateSharedLink({ sharedLink }) {
  const [generatedSharedLinks, account] = yield all([
    select(getCreatedSharedLinks),
    select(getSelectedAccount),
  ])

  let shortUrl = chain(generatedSharedLinks)
    .find({ sharedLink })
    .get("shortUrl")
    .value()

  if (!shortUrl) {
    const { urlTemplate, urlParams, queryString } = sharedLink
    try {
      shortUrl = yield call(apiPost, `/api/${account}/sharedLinks`, {
        urlTemplate,
        urlParams,
        queryString,
      })
      yield put(Creators.addCreatedSharedLink(shortUrl, sharedLink))
    } catch {
      yield put(NotificationCreators.add("error", null, "An error occured while creating the share link."))
    }
  }
  yield put(Creators.setSharedLink(shortUrl))
}

export function* saga() {
  yield takeLatest(Types.CREATE_SHARED_LINK, handleCreateSharedLink)
}
